import { createSlice } from "@reduxjs/toolkit";
import { globalActions } from "../actions";

const initialState = {
	items: { dict: {}, list: [] },
};

const adminProductSlice = createSlice({
	name: "adminProduct",
	initialState,
	reducers: {
		setAdminProducts: (state, action) => {
			const itemsAsList = action.payload;
			state.items.list = itemsAsList;
			state.items.dict = {};
			for (let i = 0; i < itemsAsList.length; i++) {
				const item = itemsAsList[i];
				state.items.dict[item.id] = item;
			}
		},
		addAdminProduct: (state, action) => {
			const item = action.payload;
			state.items.list.unshift(item);
			state.items.dict[item.id] = item;
		},
		updateAdminProduct: (state, action) => {
			const item = action.payload;
			state.items.dict[item.id] = item;
			const index = state.items.list.findIndex((p) => p.id === item.id);
			if (index >= 0) {
				state.items.list[index] = item;
			}
		},
		removeAdminProduct: (state, action) => {
			const id = action.payload;
			delete state.items.dict[id];
			state.items.list = state.items.list.filter((p) => p.id !== id);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(globalActions.logout, () => initialState);
	},
});

const getAdminProductItemsAsList = (state) => state.adminProduct.items.list;
const getAdminProductItemsAsDict = (state) => state.adminProduct.items.dict;

export { getAdminProductItemsAsList, getAdminProductItemsAsDict };

export default adminProductSlice;
